var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdaptability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 107.82,
    cy: 62.3,
    r: 9.83
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "124.01 140.03 124.01 170.44 112.79 170.44 112.79 140.03 103.35 140.03 103.35 170.44 92.12 170.44 91.97 140.03 82.12 140.03 91.81 107.58 73.89 57.3 83.99 53.62 93.99 80.91 121.83 80.91 132.1 52.54 142.69 55.98 124.5 107.33 124.01 140.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.13,109.05A81.21,81.21,0,0,1,187.65,87.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "15.19 86.4 27.05 110.5 47.33 92.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.62,111.57A81.2,81.2,0,0,1,30.11,133.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "202.57 134.22 190.71 110.12 170.43 128.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptability);
export default __webpack_public_path__ + "static/media/ADAPTABILITY.ab29921e53db5106b086e3fa8e8b9828.svg";
export { ForwardRef as ReactComponent };